import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  makeStyles,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useSelector, useDispatch } from "react-redux";
import { markerActions } from "../../store/actions/marker.action";
import clsx from "clsx";
import CloseIcon from "@material-ui/icons/Close";

const options = [
  "police",
  "army",
  "block",
  "water_tank",
  "medical_team",
  "stranger",
];

const useStyles = makeStyles({
  input: {
    marginBottom: "1em",
  },
  list: {
    width: 250,
    padding: 20,
  },
});

const ControlPanelAdd = ({ toggleDrawer }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const pointer = useSelector((state) => state.marker.pointer);
  const loading = useSelector((state) => state.marker.loading);
  const [state, setState] = useState({
    type: "",
    latitude: "",
    longitude: "",
    message: "",
  });

  useEffect(() => {
    setState({
      ...state,
      latitude: pointer.latitude,
      longitude: pointer.longitude,
    });
    // eslint-disable-next-line
  }, [pointer]);

  const onFormSubmit = (e) => {
    e.preventDefault();
    // console.log("state", state);
    const payload = {
      type: state.type,
      message: state.message,
      position: [state.longitude, state.latitude],
    };
    dispatch(markerActions.addNewMarkerOnMap(payload));
  };

  return (
    <div className={clsx(classes.list)} role="presentation">
      <Typography variant="h6" align="center" gutterBottom>
        New Marker
      </Typography>

      <Autocomplete
        value={state.type ?? ""}
        onChange={(event, newValue) => {
          setState({ ...state, type: newValue });
        }}
        defaultValue={state.type}
        id="controllable-states-demo"
        options={options}
        fullWidth
        className={classes.input}
        renderInput={(params) => (
          <TextField {...params} label="Data Type" variant="outlined" />
        )}
      />
      <TextField
        variant="outlined"
        fullWidth
        placeholder="Message"
        className={classes.input}
        value={state.message}
        onChange={(e) => setState({ ...state, message: e.target.value })}
      />
      <TextField
        placeholder="Latitude"
        type="number"
        variant="outlined"
        fullWidth
        className={classes.input}
        style={{ marginBottom: "1rem" }}
        value={state.latitude}
        onChange={(e) => setState({ ...state, latitude: e.target.value })}
      />
      <TextField
        placeholder="Longitude"
        type="number"
        variant="outlined"
        fullWidth
        className={classes.input}
        style={{ marginBottom: "1rem" }}
        value={state.longitude}
        onChange={(e) => setState({ ...state, longitude: e.target.value })}
      />
      <Button
        fullWidth
        variant="outlined"
        onClick={onFormSubmit}
        style={{ marginTop: 10, marginBottom: 10 }}
      >
        {loading ? "Loading..." : "Submit"}
      </Button>
      {loading && <CircularProgress />}

      <div
        style={{
          position: "absolute",
          bottom: 20,
          width: "80%",
        }}
      >
        <Button
          fullWidth
          color="secondary"
          variant="contained"
          onClick={toggleDrawer("right", false)}
          style={{ marginTop: 10 }}
        >
          Close <CloseIcon />
        </Button>
      </div>
    </div>
  );
};

export default ControlPanelAdd;
